/**
 * <language-dropdown>
 *   Custom expand-down language switcher.
 *   The trigger shows the current language; clicking it expands a list
 *   beneath it with all other options. Picking one submits the hidden
 *   Shopify localization form with the selected locale_code.
 */
class LanguageDropdown extends HTMLElement {
  connectedCallback() {
    this.#trigger = this.querySelector('[data-ld-trigger]');
    this.#menu = this.querySelector('[data-ld-menu]');
    this.#form = this.querySelector('form');
    this.#hiddenLocale = this.querySelector('[data-ld-locale]');

    if (!this.#trigger || !this.#menu || !this.#form || !this.#hiddenLocale) return;

    this.#trigger.addEventListener('click', this.#toggle);
    this.#menu.addEventListener('click', this.#onMenuClick);
    document.addEventListener('click', this.#onDocClick, true);
    document.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onDocClick, true);
    document.removeEventListener('keydown', this.#onKeydown);
  }

  #toggle = (e) => {
    e.stopPropagation();
    this.#setOpen(!this.#open);
  };

  #onDocClick = (e) => {
    if (!this.contains(e.target)) this.#setOpen(false);
  };

  #onKeydown = (e) => {
    if (e.key === 'Escape' && this.#open) {
      this.#setOpen(false);
      this.#trigger?.focus();
    }
  };

  #onMenuClick = (e) => {
    const item = e.target.closest('[data-ld-option]');
    if (!item) return;
    const code = item.getAttribute('data-ld-option');
    if (!code) return;
    this.#hiddenLocale.value = code;
    this.#form.submit();
  };

  #setOpen(open) {
    this.#open = open;
    this.classList.toggle('is-open', open);
    this.#trigger.setAttribute('aria-expanded', String(open));
    this.#menu.hidden = !open;
  }

  #trigger = null;
  #menu = null;
  #form = null;
  #hiddenLocale = null;
  #open = false;
}

if (!customElements.get('language-dropdown')) {
  customElements.define('language-dropdown', LanguageDropdown);
}
